import FilterList from 'components/FilterList';
import TableData from 'components/tableData/tableData';
import { Area } from 'models/response';
import React from 'react';
import styled from 'styled-components/macro';
import utils from 'utils';
import { formatKpiValue } from 'routes/ControlTower/utils';
import { KpiCategoryFilterConfiguration, KpiCategoryFilterValue } from 'models/request';

interface TableViewProps {
  dateTo?: string;
  dateFrom?: string;
  gbsList?: string[];
  companies?: string[];
  channels?: string[];
  types?: string[];
  categoryName?: string;
  areas?: Area[];
  unifyHeaders?: boolean;
  kpiCategoryFilterValues?: KpiCategoryFilterValue[];
  kpiCategoryFilterConfig?: KpiCategoryFilterConfiguration[];
}

const Container = styled.div`
  display: flex;
  gap: 20px;
`;

const FilterWrapper = styled.div`
  width: 220px;
  min-width: 220px;
`;

const TableWrapper = styled.div`
  overflow: auto;
  padding: 8px;
`;

const TableViewMode: React.FC<TableViewProps> = ({
  dateTo,
  dateFrom,
  gbsList,
  companies,
  channels,
  types,
  categoryName,
  areas,
  unifyHeaders,
  kpiCategoryFilterValues,
  kpiCategoryFilterConfig,
}) => {
  const t = utils.intl.useTranslator();
  return (
    <Container>
      <FilterWrapper>
        <FilterList
          dateTo={dateTo}
          dateFrom={dateFrom}
          gbsList={gbsList}
          companies={companies}
          channels={channels}
          types={types}
          categoryName={categoryName}
          kpiCategoryFilterValues={kpiCategoryFilterValues}
          kpiCategoryFilterConfig={kpiCategoryFilterConfig}
        />
      </FilterWrapper>
      <TableWrapper>
        {areas?.map((area, index) => {
          const hideHeader = unifyHeaders && index > 0;
          return (
            <TableData
              headers={hideHeader ? undefined : area.kpis.map((kpi) => kpi.name)}
              row={area.kpis.map((kpi) => formatKpiValue(t, kpi))}
              rowName={area.name}
              key={area.name}
            />
          );
        })}
      </TableWrapper>
    </Container>
  );
};

export default TableViewMode;
